<template>
  <CourtHalf
    :side="side"
    expand
    class="court"
  />
</template>

<script>
  import CourtHalf from './CourtHalf';

  export default {
    components: { CourtHalf },
    props: {
      side: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .court {
    color: color(bronze);
  }
</style>
